/**
 * URL de base de l'API (images servies par le backend).
 */
function getApiBase(): string {
  return import.meta.env.VITE_API_URL || 'http://localhost:4000';
}

/**
 * Retourne l'URL complète pour une image stockée sur le backend (uploads).
 * Les chemins relatifs sont préfixés par l'URL de l'API pour un chargement fiable.
 */
export function getImageUrl(url: string | null | undefined): string {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('data:')) return trimmed;
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;
  const base = getApiBase();
  const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return `${base.replace(/\/$/, '')}${path}`;
}
